import { StatusBadge } from "@/components/status-badge";

type RunStatus = "pending" | "processing" | "completed" | "failed" | undefined;

const runStatusConfig = {
  pending: { label: "Queued", variant: "default", showSpinner: true },
  processing: { label: "Indexing", variant: "default", showSpinner: true },
  completed: { label: "Indexed", variant: "secondary", showSpinner: false },
  failed: { label: "Failed", variant: "destructive", showSpinner: false },
  undefined: { label: "Not indexed", variant: "outline", showSpinner: false },
} as const;

export function RunStatusBadge({ status }: { status: RunStatus }) {
  const config = runStatusConfig[String(status) as keyof typeof runStatusConfig];
  return (
    <StatusBadge
      label={config.label}
      variant={config.variant}
      showSpinner={config.showSpinner}
    />
  );
}
